<button type="button" mat-icon-button aria-label="View Merged History Tree" [matTooltip]="'View Merged History Tree'"
	matTooltipPosition="above" (click)="openDialog()">
	<mat-icon class="align-icon">history</mat-icon>
</button>